export default __webpack_public_path__ + "static/media/Matter-Medium.81016e33.woff2";